let urlIO = ''
if (process.env.NODE_ENV !== "production") {
	urlIO = 'http://localhost:3060';
}

export default urlIO